import React from "react";

export default function AdvisorProfileSkeleton() {
    return (
        <div className="container camp-skeleton-wrapper">

            {/* COVER + PROFILE */}
            <div className="camp-skeleton-profile-header">
                <div className="camp-skeleton camp-skeleton-cover"></div>

                <div className="camp-skeleton-profile-info">
                    <div className="camp-skeleton camp-skeleton-avatar-lg"></div>

                    <div className="camp-skeleton-profile-text">
                        <div className="camp-skeleton camp-skeleton-title"></div>
                        <div className="camp-skeleton camp-skeleton-text small"></div>

                        <div className="camp-skeleton-rating-row">
                            <div className="camp-skeleton camp-skeleton-chip"></div>
                            <div className="camp-skeleton camp-skeleton-chip"></div>
                            <div className="camp-skeleton camp-skeleton-chip"></div>
                        </div>
                    </div>

                    <div className="camp-skeleton camp-skeleton-button"></div>
                </div>
            </div>

            {/* ABOUT + VERIFICATION */}
            <div className="row mt-4">
                <div className="col-lg-8">
                    <div className="camp-skeleton camp-skeleton-paragraph"></div>
                    <div className="camp-skeleton camp-skeleton-paragraph"></div>
                    <div className="camp-skeleton camp-skeleton-paragraph small"></div>

                    <div className="camp-skeleton-tag-row">
                        {[1, 2, 3, 4, 5].map(i => (
                            <div key={i} className="camp-skeleton camp-skeleton-tag"></div>
                        ))}
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="camp-skeleton-card">
                        <div className="camp-skeleton camp-skeleton-title"></div>

                        <div className="camp-skeleton-icon-row">
                            {[1, 2, 3, 4].map(i => (
                                <div key={i} className="camp-skeleton camp-skeleton-icon"></div>
                            ))}
                        </div>

                        <div className="camp-skeleton camp-skeleton-text small"></div>
                    </div>
                </div>
            </div>

            {/* ACCORDIONS */}
            <div className="camp-skeleton-accordion mt-4">
                <div className="camp-skeleton camp-skeleton-accordion-bar"></div>
                <div className="camp-skeleton camp-skeleton-accordion-bar"></div>
            </div>

            {/* EXPERIENCE LIST */}
            <div className="camp-skeleton-experience mt-3">
                {[1, 2, 3].map(i => (
                    <div key={i} className="camp-skeleton-exp-row">
                        <div className="camp-skeleton camp-skeleton-logo"></div>

                        <div className="flex-grow-1">
                            <div className="camp-skeleton camp-skeleton-text"></div>
                            <div className="camp-skeleton camp-skeleton-text small"></div>
                            <div className="camp-skeleton camp-skeleton-paragraph"></div>
                        </div>
                    </div>
                ))}
            </div>

            {/* CAMPAIGNS */}
            <div className="camp-skeleton-campaigns mt-4">
                <div className="camp-skeleton camp-skeleton-title"></div>

                <div className="camp-skeleton-cards-row">
                    {[1, 2, 3, 4].map(i => (
                        <div key={i} className="camp-skeleton-card campaign-card">
                            <div className="camp-skeleton camp-skeleton-image small"></div>
                            <div className="camp-skeleton camp-skeleton-text"></div>
                            <div className="camp-skeleton camp-skeleton-text small"></div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
}